import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box, IconButton } from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CloseIcon from "@mui/icons-material/Close";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

import RiteUserList from "./RiteUserList";
import RiteUserAdd from "./RiteUserAdd";
import RiteUserDetails from "./RiteUserDetails";

const RiteUserTabs = () => {
  const token = getDecryptedAccessToken();

  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [users, setUsers] = useState([]);

  const fetchUsers = async () => {
    try {
      const res = await ApiServices.get("/api/v1/admin/users/", {
        Authorization: `Bearer ${token}`,
      });

      setUsers(res?.data?.results || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const openUserTab = (user) => {
    const exist = tabs.findIndex((t) => t.id === user.id);

    if (exist === -1) {
      const newTabs = [...tabs, user];
      setTabs(newTabs);
      setSelectedTab(newTabs.length + 1);
    } else {
      setSelectedTab(exist + 2);
    }
  };

  const closeTab = (index) => {
    const newTabs = tabs.filter((_, i) => i !== index);
    setTabs(newTabs);
    setSelectedTab(1);
  };

  return (
    <Box>
      <Tabs
        value={selectedTab}
        onChange={(e, v) => setSelectedTab(v)}
        variant="scrollable"
      >
        <Tab icon={<PersonAddIcon />} label="Add User" />

        <Tab icon={<ListIcon />} label="Users List" />

        {tabs.map((tab, index) => (
          <Tab
            key={tab.id}
            label={
              <Box display="flex" alignItems="center">
                {tab.first_name}
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    closeTab(index);
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            }
          />
        ))}
      </Tabs>

      <Box mt={2}>
        {selectedTab === 0 && <RiteUserAdd onCreated={fetchUsers} />}

        {selectedTab === 1 && (
          <RiteUserList
            users={users}
            onOpen={openUserTab}
            onRefresh={fetchUsers}
          />
        )}

        {selectedTab > 1 && (
          <RiteUserDetails
            user={tabs[selectedTab - 2]}
            onRefresh={fetchUsers}
          />
        )}
      </Box>
    </Box>
  );
};

export default RiteUserTabs;
